/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Overlay from './Overlay';
import Axios from 'axios';
import backIcon from '../../../../assets/imgs/icons/arrow-back.svg';
import { TString } from '../Response/Utils';

const LoginScreen = (props) => {
	function handleMessage(e) {
		if (typeof e.data === 'string' && e.data.includes('event')) {
			var { event, redirecturl } = JSON.parse(e.data);
			if (event === 'login success') {
				Axios.get(redirecturl + '&botid=' + props.botID)
					.then((response) => {
						let data = response.data;
						let config = { isHidden: true };
						props.toggleLoginScreen();
						if (data.loginResult == 'success') {
							data.loginMessage != '' &&
								props.handleOauthLogin('success', data.loginMessage);

							data.previousQuestion &&
								data.previousQuestion != '' &&
								props.handleSubmit(data.previousQuestion, {}, config);

							data.logoutMessage && props.setLogoutMessage(data.logoutMessage);
						} else {
							props.handleOauthLogin('failure');
						}
					})
					.catch((error) => {
						console.log(error);
					});
			}
		}
	}
	function handleIframeClose() {
		props.handleOauthLogin('failure');
		props.toggleLoginScreen();
	}
	useEffect(() => {
		window.addEventListener('message', handleMessage); //NOSONAR
		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	function handleLogin(ev) {}

	return (
		<Overlay>
			<iframe
				id='login_iframe'
				onLoad={handleLogin}
				src={`${props.oauthURL}`}
				frameBorder='0'
			></iframe>
			<span
				className='close-iframe'
				title={TString({ labelName: 'exitLabel' })}
			>
				<button
					onClick={handleIframeClose}
					className='login-back-button'
					style={{ background: 'transparent', border: 'none' }}
				>
					<img src={backIcon} alt={TString({ labelName: 'backIconLabel' })} />
				</button>
			</span>
		</Overlay>
	);
};

export default LoginScreen;
